import {
  BufferAttribute,
  EdgesGeometry,
  Line,
  LineSegments,
  Mesh,
  MeshStandardMaterial,
  Points,
} from 'three';
import _ from 'underscore';

import { GeometryMesh } from '../../viewer/elements/volume/types';
import { getPositionArray } from './buffer-attribute';

export function transformInternalMeshPositions(mesh: Mesh) {
  if (mesh.position.length() > 0) {
    return;
  }

  const position = mesh.geometry.getAttribute('position') as BufferAttribute;

  mesh.position.set(position.getX(0), position.getY(0), 0);

  for (let i = 0; i <= position.count; i++) {
    position.setXYZ(
      i,
      position.getX(i) - mesh.position.x,
      position.getY(i) - mesh.position.y,
      position.getZ(i) - mesh.position.z,
    );
  }

  mesh.geometry.computeBoundingSphere();
  mesh.geometry.computeBoundingBox();
  mesh.geometry.computeVertexNormals();
}

export function isWireframe(mesh: Mesh | Line | LineSegments | Points) {
  return (
    (mesh.material as MeshStandardMaterial).wireframe === true ||
    mesh.geometry instanceof EdgesGeometry
  );
}

/**
 * Concats the vertices and indices of all the meshes provided.
 */
export function concatMeshes(meshes: Mesh[], toWorld = false) {
  const data: GeometryMesh = {
    vertices: [],
    indices: [],
  };

  for (const mesh of meshes) {
    const vertices = getPositionArray(mesh, toWorld);
    const totalVertices = data.vertices.length / 3;

    data.vertices = data.vertices.concat(vertices.flatMap((x) => x.toArray()));
    data.indices = data.indices.concat(
      mesh.geometry.index
        ? Array.from(mesh.geometry.index.array).map((index) => index + totalVertices)
        : _.times(vertices.length, ($index: number) => $index + totalVertices),
    );
  }

  return data;
}
